<template>
  <v-layout align-start>
    <v-flex>
      <v-toolbar flat color="white">
        <v-dialog v-model="dialog" max-width="1000px">
          <v-card>
            <v-card-title>
              <span class="headline">Select an item</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-text-field
                      v-model="texto"
                      @keyup.enter="listarArticulos()"
                      class="text-xs-center"
                      append-icon="search"
                      label="Busqueda"
                    ></v-text-field>
                    <template>
                      <v-data-table
                        :headers="headerArticulo"
                        :items="articulos"
                        class="elevation-1"
                      >
                        <template v-slot:[`item.seleccionar`]="{ item }">
                          <td class="justify-center layout px-0">
                            <v-icon small class="mr-2" @click="agregarDetalle(item)"
                              >add_circle</v-icon
                            >
                          </td>
                        </template>

                        <template v-slot:[`item.estado`]="{ item }">
                          <div v-if="item.estado">
                            <span class="blue--text">Active</span>
                          </div>
                          <div v-else>
                            <span class="red--text">Desactive</span>
                          </div>
                        </template>
                      </v-data-table>
                    </template>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="adModal" max-width="500px">
          <v-card>
            <v-card-title class="headline" v-if="adAccion == 1"
              >Activate Item</v-card-title
            >
            <v-card-title class="headline" v-if="adAccion == 2"
              >Deactivate Item</v-card-title
            >
            <v-card-text>
              Estas a punto de
              <span v-if="adAccion == 1" class="blue--text">ACTIVAR</span>
              <span v-if="adAccion == 2" class="red--text">DESACTIVAR</span>
              el item {{ adNombre }}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="activarDesactivarCarrar()"
                >Cancelar</v-btn
              >

              <v-btn v-if="adAccion == 2" color="red darken-1" text @click="desactivar()"
                >Desactivar</v-btn
              >

              <v-btn v-if="adAccion == 1" color="orange darken-1" text @click="activar()"
                >Activar</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="ingresos"
        :search="search"
        class="elevation-1"
        v-if="verNuevo == 0"
      >
        <template v-slot:[`item.opciones`]="{ item }">
          <v-icon class="mr-2" small @click="verIngreso(item)"> tab </v-icon>
          <v-icon v-if="item.estado" small @click="activarDesactivarMostrar(2, item)">
            block
          </v-icon>
          <v-icon v-else small @click="activarDesactivarMostrar(1, item)"> check </v-icon>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <div v-if="item.estado">
            <span class="blue--text">Aceptado</span>
          </div>
          <div v-else>
            <span class="red--text">Anulado</span>
          </div>
        </template>
        <template v-slot:top>
          <v-toolbar text>
            <v-toolbar-title>Ingresos</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-if="verNuevo == 0"
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              v-if="verNuevo == 0"
              @click="mostrarNuevo()"
              dark
              class="mb-2"
              >Nuevo</v-btn
            >
          </v-toolbar>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="listar()"> Reset </v-btn>
        </template>
      </v-data-table>

      <v-container grid-list-sm class="pa-4 white" v-if="verNuevo == 1">
        <v-layout row wrap>
          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-select
              v-model="tipo_comprobante"
              :items="comprobantes"
              label="Tipo Comprobante"
            ></v-select>
          </v-col>

          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-text-field
              v-model="serie_comprobante"
              label="Serie Comprobante"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-text-field
              v-model="num_comprobante"
              label="Numero Comprobante"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="8" md="8" lg="8" xl="8">
            <v-autocomplete
              :items="personas"
              v-model="persona"
              label="Proveedor"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-text-field
              type="number"
              v-model="impuesto"
              label="Impuesto"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="8" md="8" lg="8" xl="8">
            <v-text-field
              v-model="codigo"
              label="Codigo"
              @keyup.enter="buscarCodigo()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="2" md="2" lg="2" xl="2">
            <v-btn small fab dark color="primary" @click="mostrarModalArticulos()">
              <v-icon dark>list</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" xs="12" sm="2" md="2" lg="2" xl="2" v-show="errorArticulo">
            <div class="red--text" v-text="errorArticulo"></div>
          </v-col>
          <v-flex cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <template>
              <v-data-table
                :headers="cabeceraDetalles"
                :items="detalles"
                class="elevation-1"
              >
                <template v-slot:[`item.borrar`]="{ item }">
                  <v-icon @click="eliminarDetalle(detalles, item)" small class="mr-2"
                    >delete</v-icon
                  >
                </template>
                <template class="text-xs-centro" v-slot:[`item.cantidad`]="{ item }">
                  <v-text-field v-model="item.cantidad" type="number"></v-text-field>
                </template>
                <template class="text-xs-right" v-slot:[`item.precio`]="{ item }">
                  <v-text-field v-model="item.precio" type="number"></v-text-field>
                </template>
                <template v-slot:[`item.subtotal`]="{ item }">
                  <td class="text-xs-right">US$ {{ item.cantidad * item.precio }}</td>
                </template>
                <template slot="no-data">
                  <h3>No hay articulos agregados al detalle</h3>
                </template>
              </v-data-table>
              <v-flex class="text-xs-right">
                <strong>Total Parcial:</strong>
                ${{ parseFloat((totalParcial = calcularTotal)).toFixed(2) }}
              </v-flex>
              <v-flex class="text-xs-right">
                <strong>Total Impuesto:</strong>
                ${{
                  (totalImpuesto = parseFloat((totalParcial * impuesto) / 100)).toFixed(2)
                }}
              </v-flex>
              <v-flex class="text-xs-right">
                <strong>Total Neto:</strong>${{
                  (total = parseFloat(totalImpuesto + totalParcial)).toFixed(2)
                }}
              </v-flex>
            </template>
          </v-flex>
        </v-layout>
        <v-flex cols="12" xs="12" sm="12" md="12" v-show="valida">
          <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
        </v-flex>
        <v-flex cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-2">
          <v-btn
            class="mr-2 white--text"
            color="primary"
            darken-1
            text
            @click.native="ocultarNuevo()"
            >Cancel</v-btn
          >
          <v-btn v-if="verDetalle == 0" color="success" @click.native="guardar()"
            >Save</v-btn
          >
        </v-flex>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script lang="js">
import axios from "axios";

export default {
  data() {
    return {
      dialogDelete: false,
      dialog: false,
      search: "",
      ingresos: [],
      headers: [
        { text: "Opciones", value: "opciones", sortable: false },
        { text: "Usuario", value: "usuario.nombre", sortable: true },
        { text: "Proveedor", value: "persona.nombre", sortable: true },
        { text: "Tipo Comprobante", value: "tipo_comprobante", sortable: true },
        {
          text: "Serie Comprobante",
          value: "serie_comprobante",
          sortable: false,
        },
        {
          text: "Numero Comprobante",
          value: "num_comprobante",
          sortable: false,
        },
        { text: "Fecha", value: "createdAt", sortable: false },
        { text: "Impuesto", value: "impuesto", sortable: false },
        { text: "Total", value: "total", sortable: false },
        { text: "Estado", value: "estado", sortable: false },
      ],
      _id: "",
      persona: "",
      personas: [],
      tipo_comprobante: "",
      comprobantes: ["BOLETA", "FACTURA", "TICKET", "GUIA"],
      serie_comprobante: "",
      num_comprobante: "",
      impuesto: 7,
      codigo: "",
      cabeceraDetalles: [
        { text: "Borrar", value: "borrar", sortable: false },
        { text: "Articulo", value: "articulo", sortable: false },
        { text: "Cantidad", value: "cantidad", sortable: false },
        { text: "Precio", value: "precio", sortable: false },
        { text: "Sub Total", value: "subtotal", sortable: false },
      ],
      detalles: [],
      verNuevo: 0,
      errorArticulo: null,
      total: 0,
      totalParcial: 0,
      totalImpuesto: 0,
      articulos: [],
      texto: "",
      precio_venta: "",
      descripcion: "",
      headerArticulo: [
        { text: "Seleccionar", value: "seleccionar", sortable: false },
        { text: "Codigo", value: "codigo", sortable: false },
        { text: "Nombre", value: "nombre", sortable: true },
        { text: "Categoria", value: "categoria.nombre", sortable: true },
        { text: "Stock", value: "stock", sortable: false },
        { text: "Precio Venta", value: "precio_venta", sortable: false },
        { text: "Descripcion", value: "descripcion", sortable: false },
        { text: "Estado", value: "estado", sortable: false },
      ],
      verDetalle: 0,
      valida: 0,
      validaMensaje: [],
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
    };
  },
  computed: {
    calcularTotal: function () {
      let resultado = 0.0;
      for (let i = 0; i < this.detalles.length; i++) {
        resultado = resultado + this.detalles[i].cantidad * this.detalles[i].precio;
      }
      return resultado;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.listar();
    this.selectPersona();
  },

  methods: {
    selectPersona() {
      let me = this;
      let personaArray = [];
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("persona/listProveedores", configuracion)
        .then(function (response) {
          personaArray = response.data;
          personaArray.map(function (x) {
            me.personas.push({ text: x.nombre, value: x._id });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    buscarCodigo() {
      let me = this;
      me.errorArticulo = null;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("articulo/queryCodigo?codigo=" + this.codigo, configuracion)
        .then((response) => {
          me.agregarDetalle(response.data);
        })
        .catch(function (error) {
          me.errorArticulo = "No existe el articulo";
        });
    },
    agregarDetalle(data) {
      this.errorArticulo = null;
      if (this.encuentra(data._id) == true) {
        this.errorArticulo = "El articulo ya ha sido agregado";
      } else {
        this.detalles.push({
          _id: data._id,
          articulo: data.nombre,
          cantidad: 1,
          precio: data.precio_venta,
        });
      }
      this.codigo = "";
      this.texto = "";
    },
    encuentra(id) {
      let sw = 0;
      for (let i = 0; i < this.detalles.length; i++) {
        if (this.detalles[i]._id == id) {
          sw = true;
        }
      }
      return sw;
    },
    eliminarDetalle(arr, item) {
      let i = arr.indexOf(item);
      if (i != -1) {
        arr.splice(i, 1);
      }
    },
    listarArticulos() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("articulo/list?valor=" + this.texto, configuracion)
        .then(function (response) {
          me.articulos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    mostrarModalArticulos() {
      this.dialog = true;
    },
    listarDetalles(id) {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("ingreso/querys?_id=" + id, configuracion)
        .then(function (response) {
          me.detalles = response.data.detalles;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    verIngreso(item) {
      this.limpiar();
      this.tipo_comprobante = item.tipo_comprobante;
      this.serie_comprobante = item.serie_comprobante;
      this.num_comprobante = item.num_comprobante;
      this.persona = item.persona._id;
      this.impuesto = item.impuesto;
      this.listarDetalles(item._id);
      this.verNuevo = 1;
      this.verDetalle = 1;
    },
    listar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("ingreso/list", configuracion)
        .then((response) => {
          me.ingresos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiar() {
      this._id = "";
      this.tipo_comprobante = "";
      this.serie_comprobante = "";
      this.num_comprobante = "";
      this.impuesto = 7;
      this.codigo = "";
      this.total = "";
      this.totalParcial = "";
      this.totalImpuesto = "";
      this.detalles = [];
      this.verNuevo = 0;
      this.valida = 0;
      this.validaMensaje = [];
      this.verDetalle = 0;
    },
    validar() {
      this.valida = 0;
      this.validaMensaje = [];
      if (!this.persona) {
        this.validaMensaje.push("Seleccione un proveedor.");
      }
      if (!this.tipo_comprobante) {
        this.validaMensaje.push("Seleccione un tipo de comprobante.");
      }
      if (!this.num_comprobante) {
        this.validaMensaje.push("Ingrese el numero de comprobante.");
      }
      if (!this.impuesto) {
        this.validaMensaje.push("Ingrese valor de impuesto.");
      }
      if (this.detalles.length <= 0) {
        this.validaMensaje.push("Ingrese al menos un articulo al detalles.");
      }

      if (this.validaMensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    mostrarNuevo() {
      this.verNuevo = 1;
    },
    ocultarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },
    guardar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      if (this.validar()) {
        return;
      }

      // Codigo para guardar
      axios
        .post(
          "ingreso/add",
          {
            persona: this.persona,
            usuario: this.$store.state.usuario._id,
            tipo_comprobante: this.tipo_comprobante,
            serie_comprobante: this.serie_comprobante,
            num_comprobante: this.num_comprobante,
            impuesto: this.impuesto,
            total: this.total,
            detalles: this.detalles,
          },
          configuracion
        )
        .then(function (response) {
          me.limpiar();
          me.close();
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    activarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.num_comprobante;
      this.adId = item._id;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        adModal = 0;
      }
      // this.dialogDelete = true;
      // console.log(item.usuario.nombre);
      // console.log(item._id);
    },
    activarDesactivarCarrar() {
      this.adModal = 0;
    },

    activar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("ingreso/activate", { _id: this.adId }, configuracion)
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    desactivar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "ingreso/deactivate",
          {
            _id: this.adId,
          },
          configuracion
        )
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    close() {
      this.dialog = false;
      this.texto = "";
    },

    // closeDelete() {
    //   this.dialogDelete = false;
    //   this.$nextTick(() => {
    //     this.editedItem = Object.assign({}, this.defaultItem);
    //     this.editedIndex = -1;
    //   });
    // },
  },
};
</script>
